import { render } from "./MobileTabBar.vue?vue&type=template&id=3f810766&scoped=true"
import script from "./MobileTabBar.vue?vue&type=script&lang=js"
export * from "./MobileTabBar.vue?vue&type=script&lang=js"

import "./MobileTabBar.vue?vue&type=style&index=0&id=3f810766&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f810766"]])

export default __exports__